/** @format */

import React from "react";
import { useLocation } from "react-router-dom";
import { NavBarContainer } from "../../components-v2/navbar/Navbar";

export const ConditionalNavbar = () => {
	const location = useLocation();

	const isUserProfile = /^\/user\/[^\/]+(\/|$)/.test(location.pathname);
	const isCircleDetail = /^\/circle\/[^\/]+$/.test(location.pathname);
	const isHostedPayPage = /^\/pay\/[^\/]+$/.test(location.pathname);
	const isCollectInvoiceDetail = /^\/collect\/invoices\/[^\/]+$/.test(location.pathname);
	// Help & Support (user + admin, list + detail) live inside the Collect
	// workspace shell — keep the circle navbar hidden on all of them.
	const isCollectSupportPage = /^\/collect\/(admin\/)?support(\/[^\/]+)?$/.test(location.pathname);

	const pathWithoutNavbar = [
		"/",
		"/circle/sign-up",
		"/circle/sign-in",
		"/circle/sign-in/",
		"/collect/sign-in",
		"/collect/sign-up",
		"/collect",
		"/collect/dashboard",
		"/collect/invoices",
		"/collect/invoices/:invoiceId",
		"/collect/recovery",
		"/collect/promises",
		"/collect/replies",
		"/collect/tasks",
		"/collect/review-queue",
		"/collect/legal-action",
		"/collect/campaigns",
		"/collect/templates",
		"/collect/recommendations",
		"/collect/team",
		"/collect/activity",
		"/collect/settings",
		"/collect/review",
		"/collect/customers",
		"/collect/customers/:customerId",
		"/collect/connect",
		"/collect/predictions",
		"/collect/forgot-password",
		"/collect/analytics",
		"/collect/billing",
		"/collect/subscribe",
		"/collect/admin",
		"/collect/support",
		"/collect/admin/support",
		"/collect/verify",
		"/applications/leader",
		"/circle-create",
		"/my-circles",
		"/circles",
		"/add-request",
		"/verify",
		"/join-requests",
		"/admin/dashboard",
		"/admin/circle-leader/applications",
		"/admin/view-all/users",
		"/admin/view-all/circles",
		"/admin/view-all/join-requests",
		"/admin/view-all/add-requests",
		"/admin/view-all/users/auto-draft",
		"/admin/view-all/auto-draft/reports",
		"/admin/view-all/contribution/reports",
		"/admin/view-all/payout/reports",
		"/admin/view-all/revenue/reports",
		"/account-banned",
		"/account-deleted",
		"/view-invitation",
		"/invitation-approvals",
		"/admin/view-all/invitations",
		"/business/survey",
		"/business",
		"/business/pricing",
	];

	const showNavbar =
		!pathWithoutNavbar.includes(location.pathname) &&
		!isUserProfile &&
		!isCircleDetail &&
		!isHostedPayPage &&
		!isCollectInvoiceDetail &&
		!isCollectSupportPage

	// return showNavbar ? <Navbar /> : null;
	return showNavbar ? <NavBarContainer /> : null;
};
